var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkippedBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "55px",
    viewBox: "0 0 90 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "58F8CB0B-0060-49D1-8E38-07E292AA3787@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.35,
    strokeDasharray: 5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skipped-Box-States",
    transform: "translate(-348.000000, -351.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(349.000000, 352.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.494444444,5.16360294 L11.3984759,0 L88.5055556,0 L88.5055556,48.03125 L78.0883112,53 L0.494444444,53 L0.494444444,5.16360294 Z",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.494444444,5.06617647 L78.0883112,5.06617647 L88.5055556,8.96155578e-13 M78.0883112,5.06617647 L78.0883112,53",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkippedBox);
export default __webpack_public_path__ + "static/media/skipped-box.c6eefd51d3d35dbe2a56a80cc0293e7c.svg";
export { ForwardRef as ReactComponent };